import { render } from "./floor.vue?vue&type=template&id=4f06c7fc"
import script from "./floor.vue?vue&type=script&lang=js"
export * from "./floor.vue?vue&type=script&lang=js"

import "./floor.vue?vue&type=style&index=0&id=4f06c7fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__